import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { saveCampaign } from '../../../store/actions/campaignActions';
import { deepPurple } from '../../../style/color';

const styles = theme => ({
  root: {
    width: '100%'
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: '100%',
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    marginTop: theme.spacing.unit * 3,
    marginBottom: theme.spacing.unit * 3,
    padding: theme.spacing.unit * 2,
    [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
      marginTop: theme.spacing.unit * 6,
      marginBottom: theme.spacing.unit * 6,
      padding: theme.spacing.unit * 3
    }
  },
  stepper: {
    padding: `${theme.spacing.unit * 3}px 0 ${theme.spacing.unit * 5}px`,
    marginBottom: '20px'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center'
  },
  nextButton: {
    marginTop: theme.spacing.unit * 3,
    color: '#ffffff',
    paddingLeft: 50,
    paddingRight: 50
  },
  backButton: {
    marginTop: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit,
    color: '#000000',
    paddingLeft: 50,
    paddingRight: 50
  },
  stepLabel: {
    color: 'white'
  },
  stepTitleText: {
    color: deepPurple
  }
});

const mapStateToProps = state => {
  return {
    profile: state.firebase.profile
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveCampaignHandler: campaignInfo =>
      dispatch(saveCampaign(campaignInfo, ownProps))
  };
};

export default compose(
  compose(
    connect(
      mapStateToProps,
      mapDispatchToProps
    ),

    withProps(({ profile }) => ({
      profile
    })),

    withStyles(styles)
  ),
  // Add props.router (used in handlers)
  withRouter
);



// WEBPACK FOOTER //
// ./src/components/company/campaign/CreateCampaign.enhancer.js